export default __webpack_public_path__ + "static/media/img-dollar.85412121.svg";